import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { BASE_URL } from "utils/utils";

const OrderDetails = ({ data }) => {
  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button
          className="rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear"
          variant="outline"
          size="sm"
        >
          تفاصيل
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-bold">
            التفاصيل
          </DialogTitle>
        </DialogHeader>
        <DialogBody className="max-h-[60vh] overflow-y-auto py-4">
          {/*
          "text": "تجربه ", nullable
           "plan": "images/1740991674464--image_picker_10FAEB85-19B7-49FF-A93B-C1414572ABFC-21435-0000088E6D9D05D6.jpg", nullable
           "desiredDesign": "images/1740388385417--scaled_e2644335-c51f-448a-a3c1-cfd30ab037f62191502205309809453.jpg", nullable
           */}
          {data?.text && (
            <div className="rounded-md border p-4 shadow-sm">
              <h3 className="text-center text-2xl font-bold">النص المطلوب</h3>
              <p className="text-center">{data.text}</p>
            </div>
          )}

          {data?.plan && (
            <div className="mt-4 rounded-md border p-4 shadow-sm">
              <h3 className="text-center text-2xl font-bold">الخطة المطلوبة</h3>
              <img
                crossOrigin="anonymous"
                src={`${BASE_URL}/${data.plan}`}
                alt=""
                className="w-full rounded-md"
              />
            </div>
          )}

          {data?.desiredDesign && (
            <div className="mt-4 rounded-md border p-4 shadow-sm">
              <h3 className="text-center text-2xl font-bold">
                التصميم المطلوب
              </h3>
              <img
                crossOrigin="anonymous"
                src={`${BASE_URL}/${data.desiredDesign}`}
                alt=""
                className="w-full rounded-md"
              />
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إغلاق</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default OrderDetails;
